import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

/**
 * Renders the file form
 * 
 * @param {Function} register - The form registration function
 * @param {Object} errors - The form errors object
 * @returns The file form
 */
const FileForm = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid
      gap={"8px"}
      templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(4, 1fr)" }}
      templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(2, 1fr)" }}
    >
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.adultsNumber}>
          <FormLabel fontSize={12} htmlFor={"adultsNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.adultsNumber.title</Trans>
          </FormLabel>
          <Input
            id={"adultsNumber"}
            placeholder={t("beneficiaryFile.form.adultsNumber.placeholder")}
            type={"number"}
            backgroundColor={"#2D313A"}
            {...register("adultsNumber", {
              required: t("beneficiaryFile.form.adultsNumber.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.adultsNumber && errors.adultsNumber.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"returnDate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.returnDate.title</Trans>
          </FormLabel>
          <Input id={"returnDate"} type={"date"} style={{ colorScheme: "dark" }} backgroundColor={"#2D313A"} {...register("returnDate")} />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"hospitalAdmission"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.hospitalAdmission.title</Trans>
          </FormLabel>
          <Input
            id={"hospitalAdmission"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("hospitalAdmission")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"immobilisationStart"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.immobilisationStart.title</Trans>
          </FormLabel>
          <Input
            id={"immobilisationStart"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("immobilisationStart")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.childrenNumber}>
          <FormLabel fontSize={12} htmlFor={"childrenNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.childrenNumber.title</Trans>
          </FormLabel>
          <Input
            id={"childrenNumber"}
            placeholder={t("beneficiaryFile.form.childrenNumber.placeholder")}
            type={"number"}
            backgroundColor={"#2D313A"}
            {...register("childrenNumber", {
              required: t("beneficiaryFile.form.childrenNumber.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.childrenNumber && errors.childrenNumber.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"arrivalDate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.arrivalDate.title</Trans>
          </FormLabel>
          <Input
            id={"arrivalDate"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("arrivalDate")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"hospitalEnd"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.hospitalEnd.title</Trans>
          </FormLabel>
          <Input
            id={"hospitalEnd"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("hospitalEnd")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"immobilisationEnd"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.immobilisationEnd.title</Trans>
          </FormLabel>
          <Input
            id={"immobilisationEnd"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("immobilisationEnd")}
          />
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default FileForm;
